const CommissionCycle = {
    MONTHLY: { value: 1, label: 'Mensal' },
    BIMONTHLY: { value: 2, label: 'Bimestral' },
    QUARTERLY: { value: 3, label: 'Trimestral' },
    SEMIANNUAL: { value: 6, label: 'Semestral' },
    ANNUAL: { value: 12, label: 'Anual' },

    // Helper methods
    getOptions() {
        return Object.values(this).filter(item => item.value !== undefined)
    },

    getLabel(value) {
        const option = Object.values(this).find(cycle => cycle.value === value)
        return option ? option.label : null
    },

    getByValue(value) {
        return Object.values(this).find(cycle => cycle.value === value)
    },
}

// Freeze para tornar imutável
Object.freeze(CommissionCycle)

export default CommissionCycle
